// extracted by mini-css-extract-plugin
export default {"container":"CourseManagement_container__A3SVL","listTitle":"CourseManagement_listTitle__GyQBm","loadingMessage":"CourseManagement_loadingMessage__-CZo-"};